module.exports = __webpack_public_path__ + "static/media/everyday_digital_full_crop.1d85e9a1.webp";